export default "__VITE_ASSET__YuL2wkHp__"